import { createEpic, createDownloadEpic } from "../helpers";

import {
	getUsersAsyncAction,
	createUserAsyncAction,
	updateUserStatusAsyncAction,
	exportUserDataAsyncAction,
} from "./userActions";

export const getUsersEpic = createEpic(
	getUsersAsyncAction,
	"user",
	"getUsers",
	true
);

export const createUserEpic = createEpic(
	createUserAsyncAction,
	"user",
	"createUser",
	true
);

export const updateUserStatusEpic = createEpic(
	updateUserStatusAsyncAction,
	"user",
	"updateUserStatus",
	true
);

export const exportPlayersEpic = createDownloadEpic(
	exportUserDataAsyncAction,
	"user",
	"exportUsers",
	true,
	"users"
);
